export var EnvironmentType;

(function (EnvironmentType) {
  EnvironmentType["DEVELOPMENT"] = "development";
  EnvironmentType["PRODUCTION"] = "production";
})(EnvironmentType || (EnvironmentType = {}));